// extracted by mini-css-extract-plugin
export default {"chip":"coming-soon-chip_chip__16nU4"};